export const getPhoneNumberElements = (phoneNumber: string) => {
    const number = Number(phoneNumber.split(" ")[1]).toString();
    const code = Number(phoneNumber.split(" ")[0]);

    return {code, number};
};
export const getPhoneNumberElements = (phoneNumber: string) => {
    const number = Number(phoneNumber.split(" ")[1]).toString();
    const code = Number(phoneNumber.split(" ")[0]);

    return {code, number};
};
